const settings = () => {
  let localData;
  try {
    localData = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );
  } catch (error) {
    throw new Error({
      status: 401,
      code: "NoLocalStore",
      message: "Need to login first",
    });
  }
  const username = localData?.username;
  const id = localData?.id;
  const lang = localData?.lan ?? "th-TH";
  const redeemCash = localData?.redeemCash;
  const redeemPoint = localData?.redeemPoint;
  const earnCash = localData?.earnCash;
  const earnPoint = localData?.earnPoint;
  const rewardItemId = localData?.rewardItemId;
  const rewardInstanceId = localData?.rewardInstanceId;
  const currency = localData?.currency;
  const merchantName = localData?.merchantName;
  const branchName = localData?.branchName;
  const branchId = localData?.branchId;
  const realmId = localData?.realmId;
  const firstName = localData?.firstname;
  const lastName = localData?.lastname;
  const token = localData?.access_token;
  const branches = localData?.branches;
  const vat = process.env.REACT_APP_VAT;
  const roleName = localData?.roleName;
  const authorizes = localData?.authorizes;
  const clientToken = localData?.client_token;
  const taxId = process.env.REACT_APP_TAXID;
  const showVat = process.env.REACT_APP_DISPLAY_VAT === "yes";
  const shopName = process.env.REACT_APP_SHOP_NAME;
  const isLiteMode = process.env.REACT_APP_LITE_MODE === "yes";
  const isHideProductCode =
    process.env.REACT_APP_CUSTOM_HIDE_PRODUCT_CODE === "yes";
  const receiptFooter = process.env.REACT_APP_RECEIPT_FOOTER;
  const apiVersion = process.env.REACT_APP_API_VERSION;
  return {
    id,
    username,
    branches,
    lang,
    redeemCash,
    redeemPoint,
    earnCash,
    earnPoint,
    realmId,
    rewardItemId,
    rewardInstanceId,
    currency,
    branchId, //Current branch
    vat,
    merchantName,
    branchName,
    firstName,
    lastName,
    token,
    roleName,
    authorizes,
    clientToken,
    taxId,
    showVat,
    shopName,
    isLiteMode,
    isHideProductCode,
    receiptFooter,
    apiVersion,
  };
};

const changeBranch = (newBranchId, newBranchName) => {
  try {
    const localData = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );

    localStorage.setItem(
      process.env.REACT_APP_LOCAL_STORAGE_NAME,
      JSON.stringify({
        ...localData,
        branchId: newBranchId,
        branchName: newBranchName,
      })
    );

    return true;
  } catch (error) {
    throw new Error({
      status: 401,
      code: "NoLocalStore",
      message: "Need to login first",
    });
  }
};

const havePermission = (code, action) => {
  try {
    const { authorizes } = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
    );

    const auth = authorizes.find((auth) => auth.object_code === code);

    if (!auth) return false;

    const actionResult = auth.action_codes?.find((act) => act === action);

    if (!actionResult) {
      return false;
    }

    return true;
  } catch (error) {
    alert("Need to login first");
  }
};

const saveLocale = (locale) => {
  try {
    localStorage.setItem("LOCALE", String(locale));

    return [true, null];
  } catch (error) {
    return [null, error];
  }
};
const loadLocale = () => {
  try {
    const locale = localStorage.getItem("LOCALE");

    if (!locale) return ["th", null];
    else return [locale, null];
  } catch (error) {
    return [null, error];
  }
};

const isLiteVersion = () => {
  return process.env.REACT_APP_LITE_MODE === "yes";
};

export default settings;
export { changeBranch, havePermission, saveLocale, loadLocale, isLiteVersion };
